const DEFAULT_TTL_MS = 60 * 1000
const cache = {}

module.exports = async function evenMoreSimpleCache({ apiClosure, id, ttl = DEFAULT_TTL_MS }) {
  if (cache[id]) return cache[id]
  const { data } = await apiClosure()
  cache[id] = data
  setTimeout(() => {
    delete cache[id]
  }, ttl)
  return data
}
